/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { Section } from 'ui/molecules/Section/Section';

import styles from './BusinessCreditRiskAudience.module.scss';

import { getAudienceRows } from './BusinessCreditRiskAudience.data';

export const BusinessCreditRiskAudience = () => {
  const { t } = useInt();

  return (
    <Section
      className={styles.root}
      title={t('Who uses credit risk data')}
      description={t('The same file, read for six different decisions. Each team leans on a different part of it.')}
      align="left"
    >
      <div className={styles.rows}>
        {getAudienceRows(t).map((row) => (
          <div className={styles.row} key={row.role}>
            <div className={styles.roleCol}>
              <b>{row.role}</b>
              <span>{row.context}</span>
            </div>
            <div className={styles.descCol}>
              <p>{row.text}</p>
              <span className={styles.fields}>{row.fields}</span>
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
};
